export const UploadStatuses = {
  initialised: 'initialised',
  kadasterPlanned: 'kadaster-planned',
  kadasterRequested: 'kadaster-requested',
  kadasterReceived: 'kadaster-received',
  zipUploaded: 'zip-uploaded',
  unzipStarted: 'unzip-started',
  unzipped: 'unzipped',
  dbImportStarted: 'db-import-started',
  dbImported: 'db-imported',
  postProcessingStarted: 'post-processing-started',
  active: 'active',
  inactive: 'inactive',
  failed: 'failed',

  // Deprecated statusses
  planned: 'planned',
  requested: 'requested',
  processingUpload: 'processing-upload',
  waitingForEtl: 'waiting-for-etl',
  automationKickoff: 'automation-kickoff',
  fmeIsProcessing: 'fme-is-processing',
  workspaceFailed: 'workspace-failed',
} as const;

export type UploadStatus = (typeof UploadStatuses)[keyof typeof UploadStatuses];

export const UPLOAD_STATUSSES = Object.values(UploadStatuses) as UploadStatus[];

/** Statuses between receiving the zip and becoming active; an upload shouldn't linger here. */
export const PROCESSING_UPLOAD_STATUSSES: UploadStatus[] = [
  UploadStatuses.zipUploaded,
  UploadStatuses.unzipStarted,
  UploadStatuses.unzipped,
  UploadStatuses.dbImportStarted,
  UploadStatuses.dbImported,
  UploadStatuses.postProcessingStarted,
];
